import { PauseCircleOutline, PlayCircleOutline } from '@mui/icons-material';
import { lang } from 'src/utils';

import type { IPlaybackControls } from './PlaybackControls.interface';
import { ControlButton, ControlsRow } from './PlaybackControls.styled';

export const PlaybackControls = (props: IPlaybackControls) => {
  const { status, play, resume, pause, disabled = false } = props;

  const isPlaying = status === 'PLAYING';

  const handlePlayClick = () => {
    if (status === 'PAUSED') {
      resume();
    } else {
      play();
    }
  };

  return (
    <ControlsRow data-testid="playback-controls">
      {isPlaying ? (
        <ControlButton
          aria-label={lang.scheduleComponent.playback.pause}
          onClick={pause}
          disabled={disabled}
          size="small">
          <PauseCircleOutline />
        </ControlButton>
      ) : (
        <ControlButton
          aria-label={lang.scheduleComponent.playback.play}
          onClick={handlePlayClick}
          disabled={disabled}
          size="small">
          <PlayCircleOutline />
        </ControlButton>
      )}
    </ControlsRow>
  );
};
